import React, {Component} from 'react';
import classNames from 'classnames';
import isTaxonomyActive from '../utils/isTaxonomyActive';

const MAX_LINKS = 8;

class Filter extends Component {
	constructor() {
		super();
		this.state = {isOpen: false};
	}

	toggleOpen = () => {
		this.setState({isOpen: !this.state.isOpen});
	}

	render() {
		const {
			filter,
			query,
			addFilter,
			removeFilter,
		} = this.props;

		const {
			isOpen
		} = this.state;

		const isAboveThreshold = filter.taxonomies.length > MAX_LINKS;
		const taxonomies = (isAboveThreshold && !isOpen) ? filter.taxonomies.slice(0, MAX_LINKS) : filter.taxonomies;

		const filterLinks = taxonomies.map(taxonomy => {
			const active = isTaxonomyActive(query, taxonomy._type, taxonomy.slug);
			const onClick = active
			? () => removeFilter(taxonomy)
			: () => addFilter(taxonomy);

			return (
				<li key={taxonomy.slug}>
					<button
						title={`Toggle ${taxonomy.title}`}
						onClick={onClick}
						name={`Toggle ${taxonomy.title}`}
						className="dib sans--small filter-list__item">
						<span
							className={classNames('input--checkbox pad vam dib', {active})}
						/>
						<span className="dib vam fw--500">
							{taxonomy.title}
						</span>
					</button>
				</li>
			);
		});

		return (
			<div className="bt--gray-border pt2 pb2">
				<h2 className="sans--small uppercase fw--600 mb1">
					{filter.title}
				</h2>
				<div
					className={classNames({
						'filter-list__container-gradient': filterLinks.length > MAX_LINKS
					})}>
					<ul
						className={classNames({
							'filter-list__container-overflow': filterLinks.length > MAX_LINKS
						})}>
						{filterLinks}
						{(isAboveThreshold && !isOpen) && (
							<button
								className="db sans--small link--opacity fw--600 mt1"
								onClick={this.toggleOpen}>
								Show {filter.taxonomies.length - MAX_LINKS} More
							</button>
						)}
					</ul>
				</div>
			</div>
		);
	}
}

export default class ProductFilterList extends Component {
	render() {
		const {
			query,
			filters = [],
			activeFilters = [],
			removeFilter,
			addFilter,
			clearFilters,
		} = this.props;

		const headline = (
			<h2 className="mb1">
				<span className="sans--small uppercase fw--600 mr1">
					Applied Filters
				</span>
				{activeFilters.length > 0 && (
					<button
						title="Clear All"
						onClick={clearFilters}
						className="sans--small link--gray-black">
						Clear All
					</button>
				)}
			</h2>
		);
	
		const activeFilterList = activeFilters.length > 0 ? (
			<div className="mb2">
				<ul className="list list--horizontal list--forward gutter--small list--vertical-gutter">{activeFilters.map(filter => (
					<li
						key={filter.slug}
						className="list__item">
						<button
							onClick={() => removeFilter(filter)}
							title={`Remove ${filter.title}`}
							className="db button--filter">
							{filter.title}
						</button>
					</li>
				))}</ul>
			</div>
		) : (
			<p className="button--pill-placeholder color--gray-text sans--small mb1">
				Showing all products.
			</p>
		);
	
		const filterCategoryList = filters.map((filter, index) => (
			<Filter
				key={index}
				filter={filter}
				query={query}
				addFilter={addFilter}
				removeFilter={removeFilter}
			/>
		));
	
		return (
			<React.Fragment>
				{headline}
				{activeFilterList}
				{filterCategoryList}
			</React.Fragment>
		);
	}
}